module.exports = __webpack_public_path__ + "img/application-img.f8405ee9.svg";